import React, { useEffect, useState } from "react";
import "../../assets/css/Actualites/Actualites_Poste.css";
import { API_BASE_URL } from "../../utils/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSuitcaseMedical,
    faGraduationCap,
    faHandshakeAngle,
    faHandHoldingHeart,
    faGears,
} from "@fortawesome/free-solid-svg-icons";

function HomeEventsSection() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);  // État pour afficher le loader

    useEffect(() => {
        fetch(`${API_BASE_URL}/news/latest`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setEvents(data);
                setLoading(false);  // Arrêt du loader
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des événements:", error);
                setLoading(false);  // Arrêt du loader même en cas d'erreur
            });
    }, []);

    const getIconAndColor = (eventType) => {
        switch (eventType) {
            case "Dispositif de premiers secours":
                return { icon: faSuitcaseMedical, color: "orange" };
            case "Formation":
                return { icon: faGraduationCap, color: "green" };
            case "Soutien aux populations":
                return { icon: faHandHoldingHeart, color: "red" };
            case "Renfort pour les secours publics":
                return { icon: faHandshakeAngle, color: "blue" };
            case "Exercice":
                return { icon: faGears, color: "gray" };
            default:
                return { icon: null, color: "gray" };
        }
    };

    return (
        <div className="events-section container my-5">
            <h2 className="section-title">À la Une</h2>
            {loading ? (
                <div className="row">
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="col-md-4 mb-4">
                            <div className="event-tile-placeholder">
                                <div className="event-media-placeholder"></div>
                                <div className="event-content-placeholder">
                                    <div className="placeholder-title"></div>
                                    <div className="placeholder-line"></div>
                                    <div className="placeholder-line"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="row">
                    {events.map((event) => {
                        const { icon, color } = getIconAndColor(event.type);

                        return (
                            <div key={event.id} className="col-md-4 mb-4">
                                <div className="event-tile">
                                    <div className="event-tags">
                                        {event.antenne_nom && (
                                            <span className="event-tag">{event.antenne_nom}</span>
                                        )}
                                        {icon && (
                                            <span
                                                className="event-tag"
                                                style={{ backgroundColor: color }}
                                            >
                                                <FontAwesomeIcon icon={icon} />
                                            </span>
                                        )}
                                    </div>
                                    <div className="event-media">
                                        <img
                                            src={`${event.media || `https://storage.croixblanche-42.org/sfcb42-website/events/${event.id}.webp`}`}
                                            alt={event.titre}
                                        />
                                    </div>
                                    <div className="event-content">
                                        <h5 className="event-title">{event.titre}</h5>
                                        <p className="event-date">
                                            {event.date_debut === event.date_fin
                                                ? event.date_debut
                                                : `Du ${event.date_debut} au ${event.date_fin || "N/A"}`}
                                        </p>
                                        <p className="event-description">{event.description}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="col-md-4 mb-4">
                        <a
                            href="/actualites"
                            rel="noopener noreferrer"
                            className="more-events-tile"
                        >
                            <div className="event-content d-flex justify-content-center align-items-center h-100">
                                <span className="more-events-text">En voir plus ?</span>
                            </div>
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomeEventsSection;
